"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TodoListNode = exports.TodoItemNode = void 0;
const extension_task_item_1 = require("@tiptap/extension-task-item");
const extension_task_list_1 = require("@tiptap/extension-task-list");
const utils_1 = require("./utils");
exports.TodoItemNode = extension_task_item_1.TaskItem.extend({
    name: 'todoItem',
    group: 'listItems',
    addOptions() {
        return {
            nested: true,
            HTMLAttributes: {},
            taskListTypeName: 'todoList'
        };
    },
    addAttributes() {
        return {
            ...this.parent?.(),
            todoid: (0, utils_1.getDataAttribute)('todoid', { default: null, keepOnSplit: false }),
            userid: (0, utils_1.getDataAttribute)('userid', { default: null, keepOnSplit: false })
        };
    }
});
exports.TodoListNode = extension_task_list_1.TaskList.extend({
    name: 'todoList',
    addOptions() {
        return {
            itemTypeName: 'todoItem',
            HTMLAttributes: {}
        };
    }
});
//# sourceMappingURL=todo.js.map